import { ConfigurationFieldType } from '@ydistri/api-sdk';
import { useSelector } from 'react-redux';
import { useTemplateOrCalculation } from '../../../../../hooks/useTemplateOrCalculation';
import useIsConfigurationEditable from '../../../../../hooks/useIsConfigurationEditable';

export const useIsEntityListSectionDisabled = (
  categoryId: number,
  fieldType: ConfigurationFieldType,
): boolean => {
  const { id: templateOrCalculationId } = useTemplateOrCalculation();
  const isConfigurationEditable = useIsConfigurationEditable();
  const sectionStatuses = useSelector(state => state.categoryTreeReducer.entityListSectionStatus);

  if (!isConfigurationEditable) {
    return true;
  } else {
    const sectionStatus = sectionStatuses.find(
      sectionStatus =>
        sectionStatus.calculationId === templateOrCalculationId &&
        sectionStatus.categoryId === categoryId &&
        sectionStatus.fieldType === fieldType,
    );

    return sectionStatus?.disabled ?? false;
  }
};
